import React from 'react';
import {
  Body,
  Button,
  Column,
  Head,
  Html,
  Img,
  Link,
  Row,
  Section,
  Text,
} from '@react-email/components';
import { palette } from '../../theme/palette';
import { DELEGON_URL } from '../../configuration';
import { paths } from '../../routes/paths';

// --- Main Layout Components ---

export const EmailHtml = ({ children }) => (
    <Html>
        <EmailHead />
        <Body style={{ fontFamily: 'sans-serif', backgroundColor: palette.background.jobAd }}>
            <Section style={{ margin: '0 auto', maxWidth: '900px' }}>
                {children}
            </Section>
        </Body>
    </Html>
);

export const EmailHead = () => (
    <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
        <style>
          {`
            @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
            @media (max-width: 900px) {
              .header-section {
                padding-left: 5px !important;
                padding-right: 20px !important;
              }

              .body-section {
                padding-left: 10px !important;
                padding-right: 10px !important;
              }

              .body-header-col {
                display: block !important;
                width: 100% !important;
                text-align: center !important;
              }

              .weekly-body-description {
                height: 100px !important;
              }

              .blog-row {
                  margin-bottom: 0 !important;
              }
              .blog-post-wrapper {
                  width: 100% !important;
                  max-width: 366px !important;
                  display: block !important;
                  margin: 0 auto 22px auto !important;
              }

              .blog-post-image {
                  width: 100% !important;
                  min-width: 100% !important;
                  height: auto !important;
              }

              .blog-spacer-column {
                display: none !important;
              }

              .plus-column {
                width: 100% !important;
                display: block !important;
                text-align: center !important;
              }

              .plus-image {
                margin: 0 auto !important;
                display: block !important;
              }

              .plus-column-top {
                margin-bottom: 20px;
              }

              .plus-spacer-column {
                display: none !important;
              }
              
              .outer-footer-section {
                padding-left: 20px !important;
                padding-right: 20px !important;
              }

              .job-ad-role {
                  font-size: 14px !important;
                  font-weight: 500 !important;
              }

              .job-ad-buyer {
                  font-size: 12px !important;
                  font-weight: 300 !important;
              }

              .buyer-logo {
                  width: 30px !important;
                  height: 30px !important;
              }

              .creator-logo {
                  width: 25px !important;
                  height: 25px !important;
              }
            }
          `}
        </style>
        {`
        `}
    </Head>
);

// --- Section Components ---

export const EmailHeader = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{ backgroundColor: palette.background.primary }}>
        <tbody>
            <tr>
                <td className='header-section' style={{ padding: '10px 50px 10px 35px' }}>
                    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
                        <tbody>
                            <tr>
                                <td align="left">
                                    <Link href={DELEGON_URL} target="_blank">
                                        <Img
                                            width="150"
                                            height="66.72 px"
                                            src={`${DELEGON_URL}/images/LogoWhite.png`}
                                            alt="Delegon Logo"
                                            style={{ display: 'block', width: '150px', height: 'auto' }}
                                        />
                                    </Link>
                                </td>
                                <td align="right">
                                    <Link href="https://www.linkedin.com/company/delegon/" target="_blank">
                                        <Img
                                            width="32"
                                            height="32"
                                            src={`${DELEGON_URL}/images/LinkedInIcon.svg`}
                                            alt="LinkedIn Grey"
                                        />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
);

export const EmailFooter = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td
                    className="outer-footer-section"
                    style={{
                        backgroundImage: `url(${DELEGON_URL}/images/ContactInfo.png)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        padding: '47px 100px',
                    }}
                >
                    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{
                        borderRadius: '8px',
                        background: '#FFF',
                        boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
                        border: '1px solid #F2F2F2',
                    }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: '30px 50px' }}>
                                    <Row>
                                        <Column className="plus-column plus-column-top" width="100px" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                            <Img className="plus-image" src={`${DELEGON_URL}/images/Bulb.svg`} alt="Plus" style={{ display: 'block', margin: '0 auto' }} />
                                        </Column>
                                        <Column className="plus-spacer-column" style={{ width: '66px' }} />
                                        <Column className="plus-column" style={{ verticalAlign: 'middle', textAlign: 'left' }}>
                                            <Text style={{ fontSize: '25px', fontWeight: '600', color: palette.text.primary, fontFamily: "'Montserrat', sans-serif" }}>
                                                Increase your profits with plus.
                                            </Text>
                                            <Text style={{ color: palette.text.primary, fontSize: '14px', fontWeight: '400', fontFamily: "'Montserrat', sans-serif" }}>
                                                Access valuable data, trends, and expert analysis to stay ahead.
                                            </Text>
                                            <div style={{ height: '12px' }} />
                                            <Button
                                                style={{ backgroundColor: palette.primary.light, color: palette.secondary.main, borderRadius: '24px', fontFamily: "'Montserrat', sans-serif", fontWeight: '500', lineHeight: '24px', padding: '12px 24px' }}
                                                href={paths.website.plus}
                                            >
                                                Try Plus
                                            </Button>
                                        </Column>
                                    </Row>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ height: '26px' }} />
                    <Text style={{ color: palette.text.placeholder, fontSize: '12px', fontWeight: '400', lineHeight: '20px', fontFamily: "'Montserrat', sans-serif" }}>
                        This email was intended for {'{{.Subscriber.Email}}'},
                    </Text>
                    <Text style={{ color: palette.text.placeholder, fontSize: '12px', fontWeight: '400', lineHeight: '20px', fontFamily: "'Montserrat', sans-serif" }}>
                        You received this email because you signed up for an app that helps you find jobs.
                    </Text>
                    <Text style={{ color: palette.text.placeholder, fontSize: '12px', fontWeight: '400', lineHeight: '20px', fontFamily: "'Montserrat', sans-serif" }}>
                        © {new Date().getFullYear()} Delegon. All rights reserved. You can <Link href={`${DELEGON_URL}/website/unsubscribe/{{.ListName}}/{{.Subscriber.UnsubscribeToken}}`} style={{ color: palette.text.placeholder, textDecoration: 'underline' }}>unsubscribe</Link> at any time.
                    </Text>
                </td>
            </tr>
        </tbody>
    </table>
);

// Same design as EmailFooter, but without any subscriber/unsubscribe references.
// Used for transactional emails (invites, access requests, contact us) that aren't
// tied to a newsletter subscription.
export const SimpleEmailFooter = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td
                    className="outer-footer-section"
                    style={{
                        backgroundImage: `url(${DELEGON_URL}/images/ContactInfo.png)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        padding: '47px 100px',
                    }}
                >
                    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{
                        borderRadius: '8px',
                        background: '#FFF',
                        boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
                        border: '1px solid #F2F2F2',
                    }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: '30px 50px' }}>
                                    <Row>
                                        <Column className="plus-column plus-column-top" width="100px" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                            <Img className="plus-image" src={`${DELEGON_URL}/images/Bulb.svg`} alt="Plus" style={{ display: 'block', margin: '0 auto' }} />
                                        </Column>
                                        <Column className="plus-spacer-column" style={{ width: '66px' }} />
                                        <Column className="plus-column" style={{ verticalAlign: 'middle', textAlign: 'left' }}>
                                            <Text style={{ fontSize: '25px', fontWeight: '600', color: palette.text.primary, fontFamily: "'Montserrat', sans-serif" }}>
                                                Increase your profits with plus.
                                            </Text>
                                            <Text style={{ color: palette.text.primary, fontSize: '14px', fontWeight: '400', fontFamily: "'Montserrat', sans-serif" }}>
                                                Access valuable data, trends, and expert analysis to stay ahead.
                                            </Text>
                                            <div style={{ height: '12px' }} />
                                            <Button
                                                style={{ backgroundColor: palette.primary.light, color: palette.secondary.main, borderRadius: '24px', fontFamily: "'Montserrat', sans-serif", fontWeight: '500', lineHeight: '24px', padding: '12px 24px' }}
                                                href={paths.website.plus}
                                            >
                                                Try Plus
                                            </Button>
                                        </Column>
                                    </Row>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ height: '26px' }} />
                    <Text style={{ color: palette.text.placeholder, fontSize: '12px', fontWeight: '400', lineHeight: '20px', fontFamily: "'Montserrat', sans-serif" }}>
                        © {new Date().getFullYear()} Delegon. All rights reserved.
                    </Text>
                </td>
            </tr>
        </tbody>
    </table>
);

export const JobAdBodyHeader = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td className="body-header-col" align="center">
                    <Text style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '25px', fontWeight: '600', color: '#000' }}>Our Job picks for you</Text>
                </td>
            </tr>
        </tbody>
    </table>
);

export const MEMBERSHIP_LINK_QUERY = '{{if $.MembershipID}}?as={{$.MembershipID}}{{end}}';

export const JobAdBodyFooter = ({ linkQuery = '' }) => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td align="center">
                    <Button
                        style={{ backgroundColor: '#13373F', color: '#FFF', fontFamily: "'Montserrat', sans-serif", fontSize: '14px', fontWeight: '500', lineHeight: '24px', borderRadius: '24px', padding: '12px 24px' }}
                        href={`${DELEGON_URL}${paths.website.jobAds}${linkQuery}`}
                    >
                        See all jobs
                    </Button>
                </td>
            </tr>
        </tbody>
    </table>
);

export const JobAdItem = ({ jobAd, linkQuery = '' }) => (
    <a href={`${DELEGON_URL}${paths.website.jobAds}/${jobAd.Slug}${linkQuery}`} style={{ textDecoration: 'none'}}>
        <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{ border: '1px solid #F2F2F2', borderRadius: '8px', backgroundColor: '#FFF', boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)' }}>
            <tbody>
                <tr>
                    <td style={{ padding: '16px' }}>
                        <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
                            <tbody>
                                <tr>
                                    <td style={{ verticalAlign: 'middle', width: '42px' }}>
                                        <img className="buyer-logo" width="42" height="42" src={jobAd.BuyerLogoURL} style={{ borderRadius: '8px', boxSizing: 'border-box', verticalAlign: 'middle' }} alt={jobAd.BuyerName} />
                                    </td>
                                    <td style={{ paddingLeft: '10px', verticalAlign: 'middle' }}>
                                        <p className="job-ad-role" style={{
                                            fontFamily: "'Montserrat', sans-serif",
                                            color: '#000',
                                            margin: 0,
                                            lineHeight: 1.6,
                                            fontSize: '20px',
                                            fontWeight: '700',
                                        }}>
                                            {jobAd.Role}
                                        </p>
                                        <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '15px', verticalAlign: 'middle' }}>
                                                        <img width="15" height="15" src={`${DELEGON_URL}/images/Tag.svg`} alt="tag" />
                                                    </td>
                                                    <td style={{ width: 'auto', verticalAlign: 'middle', paddingLeft: '5px' }}>
                                                        <p className="job-ad-buyer" style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '12px', fontWeight: '500', lineHeight: '20px', color: '#000', margin: 0 }}>
                                                            {jobAd.BuyerName}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </a>
);

export const JobAdBody = ({ jobAds = [] }) => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{ backgroundColor: palette.background.paper }}>
        <tbody>
            <tr>
                <td className="body-section" style={{ padding: '57px 71px' }}>
                    <JobAdBodyHeader />
                    <div style={{ height: '48px' }} />
                    {jobAds.map((ad, index) => (
                        <React.Fragment key={ad.Slug}>
                            <JobAdItem jobAd={ad} />
                            {index < jobAds.length - 1 && (
                                <div style={{ height: '22px' }} />
                            )}
                        </React.Fragment>
                    ))}
                    <div style={{ height: '48px' }} />
                    <JobAdBodyFooter />
                </td>
            </tr>
        </tbody>
    </table>
);

export const BlogPostHeader = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td className="body-header-col" align="center">
                    <Text style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '25px', fontWeight: '600', color: '#000' }}>Our latest articles for you</Text>
                </td>
            </tr>
        </tbody>
    </table>
);

export const WeeklyBlogBodyFooter = () => (
    <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation">
        <tbody>
            <tr>
                <td align="center">
                    <Button
                        style={{ backgroundColor: '#13373F', color: '#FFF', fontFamily: "'Montserrat', sans-serif", fontSize: '14px', fontWeight: '500', lineHeight: '24px', borderRadius: '24px', padding: '12px 24px' }}
                        href={`${DELEGON_URL}${paths.website.blog}`}
                    >
                        See all blog posts
                    </Button>
                </td>
            </tr>
        </tbody>
    </table>
);

export const BlogPostItem = ({ post }) => {
    const truncate = (str, length) => {
        if (!str) return '';
        return str.length > length ? str.substring(0, length) + "..." : str;
    };

    const getBlogProperties = (item) => {
        // Check if item is a BlogItemWithSpacer (has a 'Blog' field)
        if (item && item.Blog) {
            return item.Blog;
        }
        // Otherwise, assume it's a direct blog object
        return item;
    };

    const blog = getBlogProperties(post);

    if (!blog) {
        return null; // Render nothing if blog is null (for padding empty cells)
    }

    return (
        <a href={`${DELEGON_URL}${paths.website.blogDetailsView(blog.Slug)}`} style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
            <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{ borderCollapse: 'collapse' }}>
                <tbody>
                    <tr>
                        <td style={{ padding: '16px' }}>
                            <img
                                className="blog-post-image"
                                src={blog.PictureURL}
                                width="332"
                                style={{
                                    borderRadius: '8px',
                                    height: 'auto',
                                    display: 'block',
                                    margin: '0 auto',
                                    maxWidth: '100%',
                                }}
                                alt={blog.Title}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '16px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '500', lineHeight: 'normal', height: '60px', overflow: 'hidden', fontFamily: "'Montserrat', sans-serif", margin: 0, wordBreak: 'break-word' }}>{blog.Title}</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '0 16px' }}>
                            <p className='weekly-body-description' style={{ fontSize: '12px', fontWeight: '300', lineHeight: '18px', height: '80px', overflow: 'hidden', fontFamily: "'Montserrat', sans-serif", margin: 0, wordBreak: 'break-word' }}>{truncate(blog.Description, 100)}</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '16px' }}>
                            <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" style={{ borderCollapse: 'collapse' }}>
                                <tbody>
                                    <tr>
                                        <td width="25" height="25" style={{ verticalAlign: 'middle' }}>
                                            <img className="creator-logo" width="25" height="25" src={blog.CreatorLogoURL} alt={blog.CreatorName} style={{ borderRadius: '8px', boxSizing: 'border-box', verticalAlign: 'middle' }} />
                                        </td>
                                        <td style={{ verticalAlign: 'middle', paddingLeft: '5px' }}>
                                            <p style={{ fontSize: '10px', margin: 0, lineHeight: 'normal', fontWeight: '400', fontFamily: "'Montserrat', sans-serif", color: "#97989F" }}>{blog.CreatorName}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </a>
    );
};
export const WeeklyBlogBody = ({ blogPosts = [] }) => {
    const rows = blogPosts.reduce((acc, post, index) => {
        const rowIndex = Math.floor(index / 3);
        if (!acc[rowIndex]) {
            acc[rowIndex] = [];
        }
        acc[rowIndex].push(post);
        return acc;
    }, []);

    return (
        <table width="100%" border="0" cellPadding="0" cellSpacing="0" role="presentation" className="body-section" style={{ padding: '57px 71px', backgroundColor: palette.background.paper }}>
            <tbody>
                <tr>
                    <td>
                        <BlogPostHeader />
                        <div style={{ height: '48px' }} />
                        <div style={{
                            margin: '0 auto',
                            maxWidth: '750px'
                        }}>
                            {rows.map((row, rowIndex) => (
                                <div key={rowIndex} className="blog-row" style={{ marginBottom: '22px', fontSize: 0, textAlign: 'left' }}>
                                    {row.map((post, postIndex) => (
                                        <div key={post.slug} className="blog-post-wrapper" style={{
                                            width: '31.33%',
                                            display: 'inline-block',
                                            verticalAlign: 'top',
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            border: '1px solid #F2F2F2',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFF',
                                            boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
                                            marginRight: (postIndex < row.length - 1) ? '2.5%' : '0',
                                        }}>
                                            <BlogPostItem post={post} />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div style={{ height: '48px' }} />
                        <WeeklyBlogBodyFooter />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};